import styled, { keyframes, StyledProps } from 'styled-components';

export type SkeletonProps = StyledProps<{
  width?: string;
  height?: string;
}>;

const skeletonAnimation = keyframes`
  from {
    transform: translateX(-50%);
  }
  to {
    transform: translateX(50%);
  }
`;

export const SkeletonStyles = styled.div<SkeletonProps>`
  width: ${(props) => (props.width ? props.width : 'auto')};
  height: ${(props) => (props.height ? props.height : 'auto')};
  display: block;
  width: 100%;
  border-radius: 3px;
  overflow: hidden;

  ::after {
    content: '';
    display: block;
    width: auto;
    height: ${(props) => (props.height ? props.height : '50px')};
    overflow: hidden;
    background: linear-gradient(to right, #fff 0%, #ddd 50%, #fff 100%);
    animation: ${skeletonAnimation} 1500ms alternate infinite;
  }
`;
